<template>
    <div class="icon-Arrow-Right"></div>
</template>